// navigation.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";

import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./components/users/Users";
import Transaction from "./pages/transaction/Transaction";
import Category from "./pages/category/Category";
import Clinics from "./pages/clinics/Clinics";
import Doctors from "./pages/doctors/Doctors";
import UsersFullview from "./pages/users/UsersFullview";
import TrasactionFullview from "./pages/transaction/fullview/TrasactionFullview";
import CURDDoctor from "./pages/doctors/Add/CURDDoctor";
import ViewClinic from "./pages/clinics/addClinics/ViewClinic";
//
import Banner from "./pages/banner/Banner";
import Notification from "./pages/notification/Notification";

import Topic from "./pages/topic/Topic";
import Labs from "./pages/labs/Labs";
///ADD
import AddCategory from "./pages/category/addCategory/AddCategory";

import AddLabs from "./pages/labs/addLabs/AddLabs";
import AddBanner from "./pages/banner/addBanner/AddBanner";
import AddTopic from "./pages/topic/addTopic/AddTopic";
import SendNotification from "./pages/notification/addNotification/AddNotification";
//FULLVIEW
import Categoryfullview from "./pages/category/fullview/Categoryfullview";

import NotificationFullview from "./pages/notification/fullview/NotificationFullview";

import Topicfullview from "./pages/topic/fullview/Topicfullview";
import AboutScreen from "./pages/Info/About";
import PrivacyScreen from "./pages/Info/privacy";
import TosScreen from "./pages/Info/tos";

/////

import Specialities from "./pages/specialities/Specialities";
import Symptoms from "./pages/symptoms/Symptoms";
import Servicies from "./pages/servicies/Servicies";

import AddSpecialities from "./pages/specialities/addSpecialities/AddSpecialities";
import AddSymptoms from "./pages/symptoms/addSymptoms/AddSymptoms";
import AddServicies from "./pages/servicies/addServicies/AddServicies";

import Specialitiesfullview from "./pages/specialities/fullview/Specialitiesfullview";
import Serviciesfullview from "./pages/servicies/fullview/Serviciesfullview";
import Symptomsfullview from "./pages/symptoms/fullview/Symptomsfullview";

import LabTestMultiSelector from "./pages/MyLab/MyLab";

import Request from "./pages/request/Request";
import Requestfullview from "./pages/request/fullview/Requestfullview";
import LabRequest from "./pages/labrequest/LabRequest";
import LabRequestfullview from "./pages/labrequest/fullview/LabRequestfullview";

import DrTimetable from "./pages//timetable/DrTimetable";
import DrTimetablefullview from "./pages/timetable/fullview/TimetableFullview";
import AddDrTimetable from "./pages/timetable/addTimetable/AddTimetable";
import InsertEntity from "./components/supabae/SupabaseSearchEntity";

//////

import Leaderboard from "./pages/leaderboard/Leaderboard";
import Mytransaction from "./pages/myTransaction/Mytransaction";
import MyCoinRequest from "./pages/myCoinRequest/MyCoinRequest";
import CoinRequest from "./pages/coinRequest/CoinRequest";
import Prizepoll from "./pages/prizepoll/Prizepoll";
import PrizepollAdd from "./pages/prizepoll/addPrizepoll/PrizepollAdd";

//FULLVIEW
import Walletfullview from "./pages/myWallet/fullview/WalletFullview";
import CoinRequestFullview from "./pages/coinRequest/fullview/CoinRequestFullview";
import GiftFullview from "./pages/prizepoll/fullview/prizepollFullview";
import LeaderboardFullview from "./pages/leaderboard/fullview/LeaderboardFullview";

const RequireAuth = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? children : <Navigate to="/login" />;
};

function Navigation() {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route path="login" element={<Login />} />
            <Route
              index
              element={
                <RequireAuth>
                  <Home />
                </RequireAuth>
              }
            />
            <Route path="users">
              <Route
                index
                element={
                  <RequireAuth>
                    <List />
                  </RequireAuth>
                }
              />

              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <UsersFullview />
                    </RequireAuth>
                  }
                />
              </Route>
            </Route>
            <Route path="transaction">
              <Route
                index
                element={
                  <RequireAuth>
                    <Transaction />
                  </RequireAuth>
                }
              />
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <TrasactionFullview />
                    </RequireAuth>
                  }
                />
              </Route>
            </Route>

            <Route path="timetable">
              <Route
                index
                element={
                  <RequireAuth>
                    <DrTimetable />
                  </RequireAuth>
                }
              />
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <DrTimetablefullview />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddDrTimetable />
                  </RequireAuth>
                }
              />
            </Route>

            {/* banner */}
            <Route path="banner">
              <Route
                index
                element={
                  <RequireAuth>
                    <Banner />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <AddBanner />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddBanner />
                  </RequireAuth>
                }
              />
            </Route>

            {/* notification */}
            <Route path="notification">
              <Route
                index
                element={
                  <RequireAuth>
                    <Notification />
                  </RequireAuth>
                }
              />
              <Route path="send">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <SendNotification />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <NotificationFullview />
                    </RequireAuth>
                  }
                />
              </Route>
            </Route>

            {/* category */}
            <Route path="category">
              <Route
                index
                element={
                  <RequireAuth>
                    <Category />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <Categoryfullview />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddCategory />
                  </RequireAuth>
                }
              />
            </Route>

            {/* specialities */}
            <Route path="specialities">
              <Route
                index
                element={
                  <RequireAuth>
                    <Specialities />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <Specialitiesfullview />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddSpecialities />
                  </RequireAuth>
                }
              />
            </Route>

            {/* symptoms */}
            <Route path="symptoms">
              <Route
                index
                element={
                  <RequireAuth>
                    <Symptoms />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <Symptomsfullview />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddSymptoms />
                  </RequireAuth>
                }
              />
            </Route>

            {/* Servicies */}
            <Route path="servicies">
              <Route
                index
                element={
                  <RequireAuth>
                    <Servicies />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <Serviciesfullview />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddServicies />
                  </RequireAuth>
                }
              />
            </Route>

            {/* labs */}
            <Route path="lab">
              <Route
                index
                element={
                  <RequireAuth>
                    <Labs />
                  </RequireAuth>
                }
              />
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <AddLabs />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddLabs />
                  </RequireAuth>
                }
              />
            </Route>
            {/* clinics */}
            <Route path="clinics">
              <Route index element={<Clinics />} />
              <Route path="fullview" element={<ViewClinic />} />
              <Route
                path="new"
                element={
                  
                    <ViewClinic />
                 
                }
              />
            </Route>
            {/* topic */}
            <Route path="topic">
              <Route
                index
                element={
                  <RequireAuth>
                    <Topic />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <Topicfullview />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <AddTopic />
                  </RequireAuth>
                }
              />
            </Route>
            {/* doctors */}
            <Route path="doctors">
              <Route
                index
                element={
                  <RequireAuth>
                    <Doctors />
                  </RequireAuth>
                }
              />
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <CURDDoctor />
                  </RequireAuth>
                }
              />
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <CURDDoctor />
                    </RequireAuth>
                  }
                />
              </Route>
            </Route>

            {/* request */}
            <Route path="request">
              <Route
                index
                element={
                  <RequireAuth>
                    <Request />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <Requestfullview />
                  </RequireAuth>
                }
              />
            </Route>
            {/* LAB request */}
            <Route path="lab-request">
              <Route
                index
                element={
                  <RequireAuth>
                    <LabRequest />
                  </RequireAuth>
                }
              />
              <Route
                path="fullview"
                element={
                  <RequireAuth>
                    <LabRequestfullview />
                  </RequireAuth>
                }
              />
            </Route>
            <Route path="my-lab">
              <Route
                index
                element={
                  <RequireAuth>
                    <LabTestMultiSelector />
                  </RequireAuth>
                }
              />
            </Route>

            {/* Prize Poll */}
            <Route path="prizepoll">
              <Route
                index
                element={
                  <RequireAuth>
                    <Prizepoll />
                  </RequireAuth>
                }
              />
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <GiftFullview />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <PrizepollAdd />
                  </RequireAuth>
                }
              />
            </Route>

            {/* my withdraw-request */}
            <Route path="withdraw-request">
              <Route
                index
                element={
                  <RequireAuth>
                    <MyCoinRequest />
                  </RequireAuth>
                }
              />
            </Route>
            {/* mytransactions */}
            <Route path="mytransactions">
              <Route
                index
                element={
                  <RequireAuth>
                    <Mytransaction />
                  </RequireAuth>
                }
              />
            </Route>
            {/* paymentrequest */}
            <Route path="paymentrequest">
              <Route
                index
                element={
                  <RequireAuth>
                    <CoinRequest />
                  </RequireAuth>
                }
              />
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <CoinRequestFullview />
                    </RequireAuth>
                  }
                />
              </Route>
            </Route>

            <Route path="wallet">
              <Route
                index
                element={
                  <RequireAuth>
                    <Walletfullview />
                  </RequireAuth>
                }
              />
            </Route>
            {/* leaderboard */}
            <Route path="leaderboard">
              <Route
                index
                element={
                  <RequireAuth>
                    <Leaderboard />
                  </RequireAuth>
                }
              />
              <Route path="fullview">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <LeaderboardFullview />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route
                path="new"
                element={
                  <RequireAuth>
                    <PrizepollAdd />
                  </RequireAuth>
                }
              />
            </Route>
            {/* about */}
            <Route path="about">
              <Route index element={<AboutScreen />} />
            </Route>
            {/* privacy */}
            <Route path="privacy">
              <Route index element={<PrivacyScreen />} />
            </Route>
            {/* about */}
            <Route path="tos">
              <Route index element={<TosScreen />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default Navigation;
